import { ArrowIcon } from "../../../../../assets/img/svg/ArrowIcon";

import { ArrowWrapper } from "../arrowStyles/ArrowStyles.styled";

const ArrowRight = () => (
  <ArrowWrapper>
    <ArrowIcon />
  </ArrowWrapper>
);
export default ArrowRight;
